import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getTiposPendenciaBox(context, dados) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposPendencia/access/listaBox", dados).then(({ data }) => {
          resolve(data);
        });
      }
    });
  },
  getTiposPendencia(context, dados) {
    if ((!dados.pagina) || (!dados.quantidadePorPagina)) {
      dados.pagina = 1;
      dados.quantidadePorPagina = 25;
    }
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposPendencia/access/listar", dados).then(({ data }) => {
          resolve(data);
        });
      }
    });
  },
  getTipoPendencia(context, dados) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposPendencia/access/obter", { ID_PENDENCIA_TIPO: dados.id, componente: dados.componente }).then(({ data }) => {
          resolve(data);
        });
      }
    });
  },
  deleteTipoPendencia(context, dados) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposPendencia/access/excluir", { ID_PENDENCIA_TIPO: dados.id, componente: dados.componente }).then(({ data }) => {
          resolve(data);
        });
      }
    });
  },
  postTipoPendencia(context, dados) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposPendencia/access/salvar", dados).then(({ data }) => {
          resolve(data);
        });
      }
    });
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};